import * as Yup from "yup";

Yup.setLocale({
  mixed: {
    required: "Поле обязательно",
  },
});

export default Yup;
